<div class="custom-dashboard">
  <label class="custom-dashboard__upload-name">{{ csvFile?.name }}</label>
  <div class="custom-dashboard__datepicker-container">
    <div class="custom-dashboard__title-container">
      <h2>{{ settings?.title ? settings.title : 'Custom dashboard' }}</h2>
      @if (settings?.lastExportedAt) {
        <div class="custom-dashboard__export-container">
          <label class="custom-dashboard__export-label">Last exported at: {{ formattedExportedDate }}</label>
          <label class="custom-dashboard__export-label">Last exported by: {{ settings?.lastExportedBy }}</label>
          <label class="custom-dashboard__export-label">Last exported file: {{ settings?.lastExportedFileName }}</label>
        </div>
      }
    </div>
    <div class="custom-dashboard__right-side">
      @if (!settings?.removeUploadOrdersButtonFromUI) {
        <div class="custom-dashboard__csv-actions">
          <pdq-input-file
            name="csv_file"
            submitButtonLabel="Upload orders"
            (onFileChange)="onCsvChange($event)"
            [supportedFormat]="['text/csv']"
            [allowClear]="false"
            maxKBSize="5000"></pdq-input-file>
          @if (csvFile) {
            <pdq-button
              [loading]="csvIsBeingUploaded"
              (onClick)="uploadCsvFile()"
              variant="primary"
              label="Process"></pdq-button>
          }
        </div>
      }
      <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
      <app-custom-datepicker
        variant="form"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [startDate]="startDate"
        [endDate]="endDate"
        (changeDateRange)="setDateRangeValue($event)"></app-custom-datepicker>
    </div>
  </div>
  <div id="custom-dashboard-container" class="custom-dashboard__content">
    @if (loading) {
      <div>
        <app-main-loader-lottie> </app-main-loader-lottie>
      </div>
    }
    @if (notFoundMsg) {
      <div class="custom-dashboard__not_found">
        <span class="custom-dashboard__not_found__err_msg">{{ notFoundMsg }}</span>
      </div>
    }
  </div>
</div>
